// custom by mr shoe
// Product downloads tab: "Download" saves the file under the merchant-supplied
// name. Shopify's CDN sends `access-control-allow-origin: *`, so the file can be
// fetched as a blob and saved locally — the plain `download` attribute is
// ignored by browsers on cross-origin links.
(function () {
  if (window.__productDownloadsInit) return;
  window.__productDownloadsInit = true;

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.product-downloads__download');
    if (!trigger) return;

    const url = trigger.getAttribute('href');
    const filename = trigger.getAttribute('data-filename');
    if (!url || !filename) return;

    event.preventDefault();
    trigger.classList.add('is-busy');

    fetch(url, { credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.blob();
      })
      .then(function (blob) {
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(function () {
          URL.revokeObjectURL(objectUrl);
        }, 1000);
      })
      .catch(function () {
        window.open(url, '_blank', 'noopener');
      })
      .finally(function () {
        trigger.classList.remove('is-busy');
      });
  });
})();
